import styled from "../../../../_snowpack/pkg/styled-components.js";
export const RowContainer = styled.tr`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
`;
